var e;!function(e){e.Top="top",e.Center="center"}(e||(e={}));export{e as LogoPosition};
//# sourceMappingURL=FinanceCalc.types.js.map
